'use client';
import React, { useState } from 'react';
import { usePathname } from 'next/navigation';
import Sticky from 'react-sticky-el';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { classes } from './styles';

interface NavbarWrapperProps {
  children: React.ReactNode;
  readonly window?: () => Window;
  isCritical?: boolean;
}

export default function NavbarWrapper({
  children,
  window,
  isCritical = true
}: NavbarWrapperProps) {
  const [isSticky, setIsSticky] = useState(false);
  const pathname = usePathname();
  const isLandingPage = pathname === '/';

  return (
    <AppBar
      component="nav"
      sx={{
        ...classes.root,
        position: isLandingPage ? 'absolute' : 'relative',
        backgroundColor: isLandingPage ? 'transparent' : 'white',
        borderBottom: isLandingPage ? 'none' : '1px solid rgba(0, 0, 0, 0.05)',
        boxShadow: 'none'
      }}
      data-test-id="app-bar"
    >
      <Sticky
        topOffset={0}
        onFixedToggle={(isFixed) => setIsSticky(isFixed)}
        stickyStyle={{
          ...classes.sticky,
          width: '100%',
          backgroundColor: 'white',
          borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)'
        }}
      >
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          {children}
        </Box>
      </Sticky>
    </AppBar>
  );
}
